import { render, staticRenderFns } from "./RateList.vue?vue&type=template&id=606deb5f&scoped=true&"
import script from "./RateList.vue?vue&type=script&lang=js&"
export * from "./RateList.vue?vue&type=script&lang=js&"
import style0 from "./RateList.vue?vue&type=style&index=0&id=606deb5f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "606deb5f",
  null
  
)

component.options.__file = "RateList.vue"
export default component.exports